import _regenerator from "/home/jenkins/workspace/AI\u5408\u89C4\u524D\u7AEF-\u6D4B\u8BD5/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/home/jenkins/workspace/AI\u5408\u89C4\u524D\u7AEF-\u6D4B\u8BD5/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.error.to-string.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array-buffer.constructor.js";
import "core-js/modules/es.array-buffer.slice.js";
import "core-js/modules/es.data-view.js";
import "core-js/modules/es.array-buffer.detached.js";
import "core-js/modules/es.array-buffer.transfer.js";
import "core-js/modules/es.array-buffer.transfer-to-fixed-length.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.replace-all.js";
import "core-js/modules/es.typed-array.uint8-array.js";
import "core-js/modules/es.typed-array.at.js";
import "core-js/modules/es.typed-array.copy-within.js";
import "core-js/modules/es.typed-array.every.js";
import "core-js/modules/es.typed-array.fill.js";
import "core-js/modules/es.typed-array.filter.js";
import "core-js/modules/es.typed-array.find.js";
import "core-js/modules/es.typed-array.find-index.js";
import "core-js/modules/es.typed-array.find-last.js";
import "core-js/modules/es.typed-array.find-last-index.js";
import "core-js/modules/es.typed-array.for-each.js";
import "core-js/modules/es.typed-array.includes.js";
import "core-js/modules/es.typed-array.index-of.js";
import "core-js/modules/es.typed-array.iterator.js";
import "core-js/modules/es.typed-array.join.js";
import "core-js/modules/es.typed-array.last-index-of.js";
import "core-js/modules/es.typed-array.map.js";
import "core-js/modules/es.typed-array.reduce.js";
import "core-js/modules/es.typed-array.reduce-right.js";
import "core-js/modules/es.typed-array.reverse.js";
import "core-js/modules/es.typed-array.set.js";
import "core-js/modules/es.typed-array.slice.js";
import "core-js/modules/es.typed-array.some.js";
import "core-js/modules/es.typed-array.sort.js";
import "core-js/modules/es.typed-array.subarray.js";
import "core-js/modules/es.typed-array.to-locale-string.js";
import "core-js/modules/es.typed-array.to-reversed.js";
import "core-js/modules/es.typed-array.to-sorted.js";
import "core-js/modules/es.typed-array.to-string.js";
import "core-js/modules/es.typed-array.with.js";
import "core-js/modules/es.uint8-array.set-from-base64.js";
import "core-js/modules/es.uint8-array.set-from-hex.js";
import "core-js/modules/es.uint8-array.to-base64.js";
import "core-js/modules/es.uint8-array.to-hex.js";
import "core-js/modules/web.atob.js";
import "core-js/modules/web.dom-exception.constructor.js";
import "core-js/modules/web.dom-exception.stack.js";
import "core-js/modules/web.dom-exception.to-string-tag.js";
import html2canvas from 'html2canvas';
import { md } from '@/utils/markdown';
import { generatePreviewShareInfo } from '@/api/law';
import { getSessionStorage } from '@/utils/storage';
export default {
  props: {
    question: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    // eslint-disable-next-line vue/require-default-prop
    answer: {
      type: Object
    }
  },
  data: function data() {
    return {
      visible: false,
      logoUrl: '',
      // logo图标
      footerUrl: '',
      // 底部图标
      shareToken: '',
      // 分享token
      linkUrl: '',
      // 分享链接
      shareBodyHeight: 0,
      // 分享内容高度
      qrCodeBase64: '',
      // 二维码图片
      filterBase64: 'data:image/png;base64,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'
    };
  },
  computed: {
    isOverFlow: function isOverFlow() {
      return this.shareBodyHeight > 1800;
    }
  },
  methods: {
    renderMessage: function renderMessage(message) {
      if (message.includes('###JUHUI###FAGUIJIEDU###')) {
        return '<div class="analysis-tag">法规解读</div>' + (message.split('###TITEL###')[1] || '未知标题');
      } else {
        return message;
      }
    },
    handleClose: function handleClose() {
      this.shareBodyHeight = 0;
      this.visible = false;
    },
    /**
     * 初始化
     */
    init: function init() {
      var _this = this;
      // 初始化分享信息
      var params = {
        aiQLogId: this.answer.qLogId,
        client: 'MINI',
        conversationId: this.answer.conversationId || getSessionStorage('conversationId'),
        userId: this.$store.getters.userInfo.id
      };

      // 生成预览分享信息
      generatePreviewShareInfo(params).then(function (_ref) {
        var data = _ref.data;
        _this.qrCodeBase64 = data.qrCodeBase64;
        _this.shareToken = data.shareToken;
        _this.linkUrl = data.urlLink;
        _this.$nextTick(function () {
          _this.shareBodyHeight = _this.$refs['shareContentRef'].clientHeight;
          setTimeout(function () {
            _this.generateImageUploadToServer();
          }, 500);
        });
      }).catch(function (_) {
        _this.$toast.clear();
      });
    },
    handleOpen: function handleOpen() {
      var _this2 = this;
      // 等待
      this.$toast.loading({
        message: '正在生成图片信息...',
        duration: 0,
        overlay: true
      });

      // 获取logo
      var logoUrl = "https://jh-library.oss-cn-guangzhou.aliyuncs.com/front/pc/logo.png?v=".concat(process.env['VUE_APP_V']);
      this.imageUrlToBase64(logoUrl).then(function (base64) {
        _this2.logoUrl = base64;

        // 获取底部图片
        var footerUrls = ['https://jh-library.oss-cn-guangzhou.aliyuncs.com/front/wechat/share_bottom_1.png'];
        var randomIndex = Math.floor(Math.random() * footerUrls.length);
        _this2.imageUrlToBase64(footerUrls[randomIndex] + '?v=' + process.env['VUE_APP_V']).then(function (base64) {
          _this2.footerUrl = base64;
          _this2.init();
        }).catch(function (_) {
          _this2.$toast.clear();
        });
      }).catch(function (_) {
        _this2.$toast.clear();
      });
      this.visible = true;
    },
    /**
     * 网络图片转base64
     * @param {string} imgUrl - 网络图片URL
     * @param {string} mimeType - 图片格式（如'image/png'，默认'image/png'）
     * @returns {Promise<string>} base64编码
     */
    imageUrlToBase64: function imageUrlToBase64(imgUrl) {
      var mimeType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'image/png';
      return new Promise(function (resolve, reject) {
        var img = new Image();
        // 关键：允许跨域（需图片服务器支持CORS）
        img.crossOrigin = 'anonymous';
        img.src = imgUrl;
        img.onload = function () {
          // 创建Canvas元素
          var canvas = document.createElement('canvas');
          var ctx = canvas.getContext('2d');
          // 设置Canvas尺寸与图片一致
          canvas.width = img.width;
          canvas.height = img.height;
          // 绘制图片到Canvas
          ctx.drawImage(img, 0, 0);
          // 转为base64（格式：data:[mimeType];base64,xxxx）
          var base64 = canvas.toDataURL(mimeType);
          resolve(base64);
        };
        img.onerror = function (err) {
          reject(new Error("\u56FE\u7247\u52A0\u8F7D\u5931\u8D25\uFF1A".concat(err.message)));
        };
      });
    },
    /**
     * 生成图片并上传到服务器
     * @returns {Promise<void>}
     */
    generateImageUploadToServer: function generateImageUploadToServer() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var targetDom, canvas, imgDataUrl, blob, formData, uploadUrl, response, result, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _context.p = 0;
              // 1. 获取目标 DOM 元素（通过 ref）
              targetDom = _this3.$refs['shareContentRef'];
              if (targetDom) {
                _context.n = 1;
                break;
              }
              alert('未找到目标 DOM 元素');
              return _context.a(2);
            case 1:
              _context.n = 2;
              return html2canvas(targetDom, {
                useCORS: true,
                // 允许跨域图片（关键：若有外部图片必须开启）
                allowTaint: true,
                // 允许污染 Canvas（避免 toDataURL 报错）
                scale: window.devicePixelRatio,
                // 按设备像素比缩放（解决模糊）
                logging: false,
                background: null // 背景透明（按需调整）
              });
            case 2:
              canvas = _context.v;
              // 3. 将 Canvas 转换为图片 URL（dataURL 格式）
              imgDataUrl = canvas.toDataURL('image/png'); // 生成 PNG 格式（可改为 image/jpeg）
              // 4. 将 dataURL 转换为 Blob 对象（用于上传）
              blob = _this3.dataURLToBlob(imgDataUrl); // 5. 创建 FormData 用于上传（符合 multipart/form-data 格式）
              formData = new FormData(); //  append(表单字段名, 文件对象, 文件名)
              formData.append('file', blob, 'dom-screenshot.png'); // 字段名需与服务器接口一致
              // 6. 上传到服务器（替换为你的实际接口 URL）
              uploadUrl = "".concat(process.env.VUE_APP_LAW_API, "/upload/oss/uploadTempFile"); // 例如：/api/upload/image
              _context.n = 3;
              return fetch(uploadUrl, {
                method: 'POST',
                body: formData
                // headers: {
                //   Authorization: 'Bearer your-token'
                // }
              });
            case 3:
              response = _context.v;
              if (response.ok) {
                _context.n = 4;
                break;
              }
              throw new Error("\u4E0A\u4F20\u5931\u8D25\uFF0C\u72B6\u6001\u7801\uFF1A".concat(response.status));
            case 4:
              _context.n = 5;
              return response.json();
            case 5:
              result = _context.v;
              // 假设服务器返回 JSON 格式

              if (result.data) {
                _this3.$toast.clear();
                wx.miniProgram.navigateTo({
                  url: "/pages/download/index?url=".concat(result.data.ossUrl, "&shareCode=").concat(result.data.preShareCode, "&linkUrl=").concat(_this3.linkUrl, "&shareToken=").concat(_this3.shareToken)
                });
                _this3.handleClose();
              }
              _this3.$toast.clear();
              _context.n = 7;
              break;
            case 6:
              _context.p = 6;
              _t = _context.v;
              console.error('图片上传失败：', _t);
              _this3.$toast.clear();
            case 7:
              return _context.a(2);
          }
        }, _callee, null, [[0, 6]]);
      }))();
    },
    // 辅助函数：将 dataURL 转换为 Blob 对象（核心步骤）
    dataURLToBlob: function dataURLToBlob(dataURL) {
      // 解析 dataURL：格式为 "data:image/png;base64,xxxxxx"
      var arr = dataURL.split(',');
      var mime = arr[0].match(/:(.*?);/)[1]; // 提取 MIME 类型（如 image/png）
      var bstr = atob(arr[1]); // 解码 base64 字符串
      var n = bstr.length;
      var u8arr = new Uint8Array(n); // 创建 Uint8 数组存储二进制数据

      // 将二进制字符串转换为 Uint8 数组
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }

      // 生成 Blob 对象
      return new Blob([u8arr], {
        type: mime
      });
    },
    /**
     * 渲染markdown 内容
     * @param answer
     * @returns {*}
     */
    renderMarkDown: function renderMarkDown(answer) {
      var message = answer.replaceAll('\\n', '\n');
      return md.render(message);
    }
  }
};